import type { IComponent } from "@Components/Component";
import { defaultAttributes } from "@Components/Component";

import * as css from "./ShoppingMallsFilters.module.css";

export interface IShoppingMallsFiltersSearchServices extends IComponent {
    selectedServicesList: string[];
    additionalServicesList: IAdditionalService[];
    onFilterChange: (category: string) => boolean;
}

export interface IAdditionalService {
    value: string;
    text: string;
}

export const ShoppingMallsFiltersSearchServices = (props: IShoppingMallsFiltersSearchServices) => {
    const renderCategoryButton = ({ value, text }: IAdditionalService, index: number): JSX.Element => {
        let initialData = props.selectedServicesList.indexOf(value) > -1;
        if (!props.selectedServicesList) {
            initialData = false;
        }

        const categoryClick = (): boolean => {
            if (!props.selectedServicesList) {
                return true;
            }

            if (props.onFilterChange) {
                return props.onFilterChange(value);
            }

            return false;
        };

        const className = (value[0].toLowerCase() + value.substring(1)) as keyof typeof css;

        return (
            <li key={index}>
                <div className={`${css.filterItem} ${initialData ? css.active : ""}`} onClick={categoryClick}>
                    <div className={css.itemImage}>
                        <span className={css[className] as string} />
                    </div>
                    <div className={css.itemText}>{text}</div>
                </div>
            </li>
        );
    };

    return (
        <div {...defaultAttributes(props, css.shoppingMallsFiltersSearchServicesComponent)}>
            {props.additionalServicesList && props.additionalServicesList.length !== 0 && (
                <ul className={css.categoriesFilter}>
                    {props.additionalServicesList.map(renderCategoryButton)}
                </ul>
            )}
        </div>
    );
};
